import { HStack, Image, VisuallyHidden, VStack } from "@chakra-ui/react";
import React from "react";
import { NavBar } from "../components/Landing/NavBar";
import { Banner } from "../components/Landing/Banner";
import { About } from "../components/Landing/About";
import { Slider } from "../components/Landing/Slider/Slider";
import { Corporations } from "../components/Landing/Corporations";
import { Download } from "../components/Landing/Download";
import { MobileNavBar } from "../components/Mobile/MobileNavBar";
import { Footer } from "../components/Landing/Footer";

export const Landing = () => {

  return (
    <VStack
      minH="100vh"
      h="auto"
      bgColor="primary.1000"
      w="100%"
      gap={0}
      py={["0px", "0px", "40px"]}
      pb={["20px", "20px", "0px"]}
    >
      <VisuallyHidden as="h1">
        Viajá Ya. La app de movilidad hecha en Córdoba para cordobeses
      </VisuallyHidden>
      <VisuallyHidden as="h2">
        Pedí tu viaje legal, barato y con choferes que hablan como vos.
      </VisuallyHidden>
      <NavBar />
      <MobileNavBar />
      <Banner />
      <HStack
        w="full"
        justifyContent="center"
        alignItems="center"
        position="relative"
      >
        <About />
        <Image
          src="/rightCar.png"
          position="absolute"
          right={0}
          bottom={["0", "0", "-50%"]}
        />
      </HStack>
      <Slider />
      <Corporations />
      <HStack
        w="full"
        justifyContent="center"
        alignItems="center"
        position="relative"
      >
        <Download />
        <Image src="/rightCar.png" position="absolute" right={0} bottom="10%" display={["none", "none", "block"]} />
      </HStack>
      <Footer />
    </VStack>
  );
};
